var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2094_6294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.0955C8 9.53974 8.22078 9.00674 8.61376 8.61376C9.00674 8.22078 9.53974 8 10.0955 8H16.9045C17.1797 8 17.4522 8.0542 17.7064 8.15951C17.9607 8.26482 18.1917 8.41917 18.3862 8.61376C18.5808 8.80834 18.7352 9.03935 18.8405 9.29359C18.9458 9.54782 19 9.82031 19 10.0955V16.9045C19 17.1797 18.9458 17.4522 18.8405 17.7064C18.7352 17.9607 18.5808 18.1917 18.3862 18.3862C18.1917 18.5808 17.9607 18.7352 17.7064 18.8405C17.4522 18.9458 17.1797 19 16.9045 19H10.0955C9.82031 19 9.54782 18.9458 9.29359 18.8405C9.03935 18.7352 8.80834 18.5808 8.61376 18.3862C8.41917 18.1917 8.26482 17.9607 8.15951 17.7064C8.0542 17.4522 8 17.1797 8 16.9045V10.0955Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82459 16C5.57472 15.86 5.36689 15.6577 5.2221 15.4134C5.07731 15.1692 5.00069 14.8917 5 14.6091V6.60151C5 5.72068 5.73333 5 6.62963 5H14.7778C15.3889 5 15.7213 5.30829 16 5.80076",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2094_6294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.c9c106925a15cf2025aac1df4cf6f789.svg";
export { ForwardRef as ReactComponent };